// removed by extract-text-webpack-plugin
module.exports = {"statusItem":"location-tooltip-statusItem--2c7GS","statusText":"location-tooltip-statusText--2HcDC","batteryContainer":"location-tooltip-batteryContainer--1ZNqO","batteryIcon":"location-tooltip-batteryIcon--m7F8V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationTooltip/location-tooltip.scss
// module id = +1dm
// module chunks = 4